/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  LessonPlanProjectError,
  LessonPlanProjectGeneration,
  LessonPlanProjectInput,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Generate project for lesson plan
 */
export const createLessonPlanProject = (
    planId: MaybeRefOrGetter<string>,
    lessonPlanProjectInput: MaybeRefOrGetter<LessonPlanProjectInput>,
 signal?: AbortSignal
) => {
      planId = toValue(planId);
lessonPlanProjectInput = toValue(lessonPlanProjectInput);

      return axiosClient<LessonPlanProjectGeneration>(
      {url: `/lesson_plan/plans/${planId}/project`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: lessonPlanProjectInput, signal
    },
      );
    }




export const getCreateLessonPlanProjectMutationKey = () => ['createLessonPlanProject'] as const;

export const getCreateLessonPlanProjectMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | LessonPlanProjectError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLessonPlanProject>>, TError,CreateLessonPlanProjectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLessonPlanProject>>, TError,CreateLessonPlanProjectMutationVariables, TContext> => {

const mutationKey = getCreateLessonPlanProjectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLessonPlanProject>>, CreateLessonPlanProjectMutationVariables> = (props) => {
          const {planId,data} = props ?? {};

          return  createLessonPlanProject(planId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLessonPlanProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createLessonPlanProject>>>
    export type CreateLessonPlanProjectMutationBody = LessonPlanProjectInput
    export type CreateLessonPlanProjectMutationError = ErrorType<SchemaValidationErrorResponse | void | LessonPlanProjectError>
    export type CreateLessonPlanProjectMutationVariables = {planId: string;data: LessonPlanProjectInput}

    /**
 * @summary Generate project for lesson plan
 */
export const useCreateLessonPlanProject = <TError = ErrorType<SchemaValidationErrorResponse | void | LessonPlanProjectError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLessonPlanProject>>, TError,CreateLessonPlanProjectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createLessonPlanProject>>,
        TError,
        CreateLessonPlanProjectMutationVariables,
        TContext
      > => {
      return useMutation(getCreateLessonPlanProjectMutationOptions(options), queryClient);
    }
